export class AppUrl {
    static addEntity = '/common/v1/common/entity.json';
    static addExceptionCalendar = '/calendar/v1/location/exception.json/';
    static addKoala = '/location/v1/location/koala.json';
    static addLocationDetail = '/location/v1/locations.json';
    static addNominee = '/location/v1/location/nominee.json/';
    static addOffice = '/common/v1/office.json';
    static addUpdateAdmin = '/admin/v1/admin.json';
    static cancelExam = '/exam/v1/exam/status.json';
    static candidateProfile = '/common/v1/common/user.json';
    static candidateUploadId = '/user/v1/user/identity.json';
    static changeStatus = '/common/v1/common/status.json';
    static checkNotification = '/notification/v1/notification/register.json/';
    static deleteOffice = '/common/v1/office/status.json';
    static domain  = '/location/v1/location/domaindetail.json';
    static downloadApprovalId = '/location/v1/location/user/identity.json';
    static downloadEligibilities = "/eligibility/v1/search.csv";
    static downloadEligibilitiesForProctorScheduling = "/eligibility/v1/searchForProctorScheduling.csv";
    static getCapacityConfigs = "/capacity/v1/search.json";
    static getChatIdleTime = '/admin/v1/chatidletime.json';
    static searchCountries = '/location/v1/countries.json';
    static saveCountry = '/location/v1/country.json';
    static getDefaultCapacityConfigs = "/capacity/v1/default.json";
    static getEligibilities  = "/eligibility/v1/search.json";
    static getEligibilityMessageCount = '/admin/v1/scheduleexam/messages/count.json';
    static getExamAddressList = '/location/v1/location/name.json';
    static getExamList = "/location/v1/location/exams.json?locationId=";
    static getExceptionCalendarData = '/calendar/v1/location/exception.json/';
    static getKoala = '/location/v1/location/koalas.json/';
    static getLocationDetail = "/location/v1/location.json?locationId=";
    static getLocationSetting = "/location/v1/location/calendar.json?locationId=";
    static getNominee = '/location/v1/location/nominees.json/';
    static getNotification = '/notification/v1/notification.json';
    static getOfficeDetail = '/common/v1/offices.json';
    static getPendingApprovals = '/location/v1/location/user/identities.json/';
    static getProctorAlertConfig = "/admin/v1/config/configs.json";
    static getProctorDataById = "/admin/v1/admin/proctor/id.json?id=";
    static getProctorDetail = "/admin/v1/admin/proctor/leads.json/";
    static getProctorGroups = "/admin/v1/admin/groups.json/";
    static getProctorNames = "/admin/v1/admin/proctors.json/?searchText=";
    static getTimeDiff = '/location/v1/location/time.json';
    static getUniversalOperationalHours = '/common/v1/operation/hours.json/';
    static getUsers = '/user/v1/search.json';
    static getYears = '/calendar/v1/location/exception/years.json/';
    static logoutUser = '/common/v1/common/logout.json';
    static pushEligibilityMessages = '/admin/v1/scheduleexam/messages/eligibilitymessages';
    static removeExceptionCalendar = '/calendar/v1/location/exception/status.json/';
    static removeNominee = '/location/v1/location/nominee.json/';
    static replaceOffice = '/common/v1/office/new.json';
    static requestDataForCombo = '/location/v1/location/type.json';
    static retireAdmin = '/common/v1/common/status.json';
    static saveProctorData = "/admin/v1/admin/proctor.json";
    static searchLocationsByFilter = "/location/v1/locations.json/";
    static settings = './assets/data/settings.json';
    static updateBlackListedExam = '/location/v1/location/exam.json';
    static updateCapacityConfigs = "/capacity/v1/capacity.json";
    static updateDefaultCapacityConfigs = "/capacity/v1/defaultCapacity.json";
    static markAsComplete = "/eligibility/v1/eligibility/session/complete.json"
    static allowUserToReschedule = "/eligibility/v1/eligibility/session/allow-reschedule.json"
    static updateLocationSetting = '/location/v1/location/settings.json';
    static updateNotification = '/notification/v1/notification/status.json';
    static updatePendingApprovals = '/location/v1/location/user/identity.json';
    static updateProctorAlertConfig = "/admin/v1/config/config.json";
    static updateProctorStatus = "/user/v1/user.json";
    static updateUniversalOperationalHours = '/common/v1/operation/hours.json/';
    static version = './version.txt';
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/appUrl.ts